// src/component/ArchiveItem/index.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const ArchiveItem = ({ article }) => {  // 移除了 onDelete，因为它未被使用
  const { title, date, tags, excerpt, id, author } = article;
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate(`/post/${id}`);
  };

  return (
    <div className="archive-item">
      <h3 className="archive-item-title">
        <a 
          href={`/post/${id}`} 
          className="archive-item-link" 
          onClick={handleClick}
          aria-label={`阅读文章 ${title}`}
        >
          {title}
        </a>
      </h3>
      <div className="archive-item-meta">
        <span className="archive-item-date">{date}</span>
        {author && <span className="archive-item-author" style={{ color: '#999', fontSize: '0.9rem', marginLeft: '10px' }}>作者: {author}</span>}
        <div className="archive-item-tags">
          {tags && tags.map((tag, index) => (
            <span key={index} className="archive-item-tag">{tag}</span>
          ))}
        </div>
      </div>
      <p className="archive-item-excerpt">{excerpt}</p>
    </div>
  );
};

export default ArchiveItem;